import { defineStore } from "pinia";

export const useVideoStore = defineStore("video", {
  state: () => ({
    videoConfigs: [], // full array from listByVideo
    devicesById: {}, // { [deviceId]: device }
    sourcesByConfigId: {}, // { [videoConfigId]: url }
    presetsByDeviceId: {},
    lastUpdatedAt: null,
  }),

  getters: {
    allVideoConfigs: (state) => state.videoConfigs,

    getVideoConfigById: (state) => (id) =>
      state.videoConfigs.find((vc) => vc.id === id) || null,

    getDeviceByVideoConfigId: (state) => (videoConfigId) => {
      const vc = state.videoConfigs.find((vc) => vc.id === videoConfigId);
      const devId = vc?.device?.id;
      if (!devId) return null;
      return state.devicesById[devId] || null;
    },

    getPresetsByDeviceId: (state) => (deviceId) => {
      if (!deviceId) return null;
      console.log(state);
      return state.presetsByDeviceId[deviceId] || null;
    },

    getSourceByVideoConfigId: (state) => (videoConfigId) =>
      state.sourcesByConfigId[videoConfigId] || "",
  },

  actions: {
    setAll({ videoConfigs, devicesById, sourcesByConfigId, presetsByDeviceId }) {
      this.videoConfigs = videoConfigs;
      this.devicesById = devicesById;
      this.sourcesByConfigId = sourcesByConfigId;
      this.presetsByDeviceId = presetsByDeviceId;
      this.lastUpdatedAt = Date.now();
    },
  },
});
